import { Component, EventEmitter, forwardRef, OnDestroy, OnInit, Output } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { CompanyService } from 'src/app/_service/company.service';
import { VesselService } from 'src/app/_service/vessel.service';
import { UserService } from 'src/app/_service/user.service';
import { TenantService } from 'src/app/_service/tenant.service';
import { OpenWebUIService } from 'src/app/_service/open-web-ui.service';
import { postUserData, editUserForm } from 'src/app/_model/user_data';
import { getCompanyData } from 'src/app/_model/company';
import { getVesselData } from 'src/app/_model/vessel';
import { DomSanitizer } from '@angular/platform-browser';
import { getTenantData } from 'src/app/_model/tenant';
import { TenantPopupComponent } from '../tenant-popup/tenant-popup.component';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogComponent } from '../../claim-center/claim-edit/confirm-dialog/confirm-dialog.component';
import * as routing from '../../../_model/routing';
import { combineLatest } from 'rxjs';
import { USER_ROLES } from 'src/app/_model/string_literal';
import { AuthService } from 'src/app/_service/auth.service';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.css'],
})

export class UserEditComponent implements OnInit, OnDestroy {
  @Output() dataChange = new EventEmitter();
  form = new editUserForm;
  editUserForm = this.form.defaultForm;
  editUserData!:postUserData;
  editMode = true;
  ismax:boolean = false;
  userID = '';
  userData!: postUserData;
  selectedRole: any;
  visible: boolean = false;
  currTenant: string | null | undefined = "";
  currTenantName: string | undefined = "";
  currRole: string | undefined = "";
  isGlobalAdmin: boolean = false;
  selectedVessel: any;
  filteredVesselList: getVesselData[] = [];
  isRegisteringOWUUserChecked = false;
  isOWUUserRegistered: boolean = false;

  constructor(
    private location: Location,
    private userService: UserService,
    private companyService: CompanyService,
    private vesselService: VesselService,
    private tenantService: TenantService,
    private openWebUIService: OpenWebUIService,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    public router: Router,
    private translate: TranslateService,
    public auth: AuthService,

  ) { }

  companyList: getCompanyData[] = [];
  vesselList: getVesselData[] = [];
  tenantList: getTenantData[] = [];
  roles = USER_ROLES;

  ngOnInit(): void {
    if (!this.userService.editUserFlag) {
      this.getUser();
    } else {
      this.initiateUser();
    }
  }

  ngOnDestroy(): void {
    this.userService.editUserFlag = false;
  }

  getCurrTenantName() {
    return this.isGlobalAdmin
      ? this.currRole
      : this.currTenantName || "No tenant";
  }

  resetEditUser() {
    this.editUserForm.reset();
  }

  onRoleChange(event: any) {
    this.isGlobalAdmin = event?.value?.id === 3 ? true : false;
  }

  setEditUserData(editUserData: postUserData){
    this.editUserForm.patchValue(<any>editUserData);
    this.currRole = this.roles.find(role => role.id === editUserData.role_id)?.name;
    this.isGlobalAdmin = editUserData.role_id === 3;
    this.selectedRole = this.roles.find(role => role.id === editUserData.role_id);
    this.tenantService.getTenantByCompanyID(editUserData?.company_id)
      .subscribe({
        next: async(value: any) => {
          this.tenantList = value;
          this.currTenant = editUserData.role_id === 3 ? null : this.tenantList.find(t => t.id === editUserData.tenant_id)?.id;
          this.currTenantName = editUserData.role_id === 3 ? "" : this.tenantList.find(t => t.id === editUserData.tenant_id)?.name;
        },
      });
  }

  getUser() {
    const currUserId = window.location.pathname.split('/').at(-1);
    this.userService.selectedUserID = String(currUserId);
    this.userService.editUserFlag = true;
    this.userService.getUserById(currUserId).subscribe({
      next: async(value: any) => {
        this.userService.editUserData = value;
        this.initiateUser();
      },
      error: (error) => {
        console.error('Error fetching user:', error);
      },
    });
  }

  initiateUser() {
    combineLatest([
      this.vesselService.vesselList$,
      this.companyService.companyList$
    ]).subscribe(([vessels, companies]) => {
      this.vesselList = vessels;
      this.companyList = companies;
      this.tenantList = this.tenantService.tenantList;
      this.isOWUUserRegistered = this.openWebUIService.userList.some((u: any) => u.email === this.userService.editUserData.email);
      this.isRegisteringOWUUserChecked = this.isOWUUserRegistered;

      this.userID = this.userService.selectedUserID;
      this.setEditUserData(this.userService.editUserData);
      this.vesselService.getVesselByManagerId(this.companyList.find(company => company?.id === this.editUserForm.get("company_id")?.value)!.id).subscribe({
        next: async(value:any) => {
          this.filteredVesselList = value;
          this.selectedVessel = this.filteredVesselList.find(vessel => vessel.id === this.editUserForm.get("vessel_id")?.value)
        },
        error: (error) => {
          console.error('Error fetching vessels:', error);
        },
      });
    });
  }

onSubmit() {
    if (this.checkSubmit()) {
      if (this.auth.isYakuin) {
        window.alert(this.translate.instant("noPermission"));
        return;
      }
      if (this.editMode) {
        // update existing user
        this.userService.userListUpdate();

        const targetRoleId = this.selectedRole?.id; 

        this.editUserForm.patchValue({
          role_id: targetRoleId, 
          tenant_id: this.currTenant
        });

        if (this.selectedVessel) {
          this.editUserForm.patchValue({vessel_id: this.selectedVessel?.id.toString()});
        }

        if (this.isRegisteringOWUUserChecked && !this.isOWUUserRegistered) {
          this.openWebUIService.registerOpenWebUIUser(
            this.editUserForm.value.email, 
            this.editUserForm.value.name, 
            this.editUserForm.value.company_id
          )
            .subscribe({
              next: (response: any) => {
                console.log(response);

                this.openWebUIService.refreshOWUUserList(() => {
                  this.isOWUUserRegistered = this.openWebUIService.userList.some((u: any) => u.email === this.userService.editUserData.email);
                  this.isRegisteringOWUUserChecked = this.isOWUUserRegistered;
                });
              },
              error: (err) => {
                window.alert(this.translate.instant("kikuhoRegisterErr") + (err?.error?.detail || "不明なエラーが発生しました。"));
              }
            });
        }
        
        // 2. REVERTED PAYLOAD: Keep existing tenant fields, but keep the strict Number conversion
        const finalPayload = {
          ...this.editUserForm.value,
          role_id: Number(this.editUserForm.value.role_id) // Keep this fix!
        };

        this.userService.submitExistingUser(finalPayload)
          .subscribe({
            error: (err) => {
              console.error("400 Bad Request Details:", err);
              window.alert(this.translate.instant("err"));
            },
            complete: () => {
              this.editUserForm.reset();
              this.dataChange.emit();
              this.location.back();
            }
          });

        this.resetEditUser();
      } else {
        return;
      }
    }
  }

  onDelete() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: { 
        title: this.translate.instant('userDeleteTitle'),
        message: this.translate.instant('userDeleteMsg'),
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.auth.isYakuin) {
          window.alert(this.translate.instant("noPermission"));
          return;
        }
        this.userService.userListUpdate();
        this.userService.deleteUserData(this.userService.selectedUserID)
        .subscribe({
          error: () => {
            window.alert(this.translate.instant("err"));
          },
          complete: () => {
            window.alert(this.translate.instant("deleted"));
            this.userService.editUserFlag = false;
            this.router.navigate([routing.UserList]);
          }
        });
      }
    });
  }

  getCompanyName() {
    return this.companyList.find(company => company.id === this.editUserForm.get("company_id")?.value)?.name;
  }

  onChangeTenant() {
    const dialogRef = this.dialog.open(TenantPopupComponent, {
      width: '450px',
      height: '240px',
      data: { currTenant: this.currTenant, company: this.editUserForm.get("company_id")?.value },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.currTenant = result.currTenant;
        this.currTenantName = this.tenantList.find(t => t.id === this.currTenant)?.name;
      }
    });
  }

  checkDelete() {
    if (window.confirm('Are you sure you want to delete the user?')) {
      return true;
    } else {
      return false;
    }
  }

  checkSubmit() {
    if (window.confirm('Can I edit this?')) {
      return true;
    } else {
      return false;
    }
  }
  onClose() {
    this.goBack();
  }
  goBack() {
    this.resetEditUser();
    this.userService.editUserFlag = false;
    this.location.back();
  }
}
